import { render } from "./DeleteHouseModal.vue?vue&type=template&id=51378e56&scoped=true"
import script from "./DeleteHouseModal.vue?vue&type=script&lang=js"
export * from "./DeleteHouseModal.vue?vue&type=script&lang=js"

import "./DeleteHouseModal.vue?vue&type=style&index=0&id=51378e56&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51378e56"]])

export default __exports__